$('body').delegate('.textbox', 'focus', function () {
    var $field = $(this).closest('.property');
    $field.addClass('property-focus');
}); 

$('body').delegate('.textbox', 'blur', function () {
    var $field = $(this).closest('.property');
    $field.removeClass('property-focus');
}); 

$('body').delegate('.mvc-form', 'input', function () {
    var $field = $(this).closest('.property');
    if (this.value.length > 0) {
        $field.addClass('property-not-empty');
    }
    else {
        $field.removeClass('property-not-empty');
    }
}); 

$('body').delegate('.dateSelect', 'focus', function () {
    var $field = $(this).closest('.property');
    $field.addClass('property-focus');
});

$('body').delegate('.dateSelect', 'blur', function () {
    var $field = $(this).closest('.property');
    $field.removeClass('property-focus');
});